import { makeStyles } from '@mui/styles'
import React from 'react'
import { env } from 'src/env.mjs'
import SignInForm from '../SignInForm'

const useStyles = makeStyles(() => ({
  logo: {
    width: '182px',
  },
  headingSeparator: {
    background: 'linear-gradient(90deg, #0077c8, #f8a700)',
    margin: '1em 0 1em 0',
    height: '0.5em',
    width: '100%',
  },
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
}))

const Header = () => {
  const classes = useStyles()
  return (
    <>
      <div className={classes.headingSeparator} />
      <div className={classes['container']}>
        <img
          alt="logo"
          className={classes.logo}
          src={`${env.NEXT_PUBLIC_BASE_PATH}/images/Logo-Header-Dentsply-260x98px.png`}
        />
        <SignInForm />
      </div>
    </>
  )
}

export default Header
